export class MdfeCancelamento {
  justificativa = null;
  constructor(justificativa) {
    this.justificativa = justificativa;
  }
}
